export enum PersonalizationFeatures {
  personalizationPro = "personalization_pro",
}
